import * as React from "react";
const IconStopRecording = (props: any) => (
    <svg

    width="30px"
    height="30px"
    viewBox="0 0 24 24"
    id="stop"
    data-name="Flat Color"
    xmlns="http://www.w3.org/2000/svg"
    className="icon flat-color"
    {...props}
  >
    <rect
      id="primary"
      x={2}
      y={2}
      width={20}
      height={20}
      rx={5}
      style={{
        fill: "#ff0100",
      }}
    />
  </svg>
);
export default IconStopRecording;
